import { render } from "./FilterTab.vue?vue&type=template&id=bba49a50"
import script from "./FilterTab.vue?vue&type=script&lang=js"
export * from "./FilterTab.vue?vue&type=script&lang=js"

import "./FilterTab.vue?vue&type=style&index=0&id=bba49a50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__